module.exports = __webpack_public_path__ + "static/media/shareplus-icon-active.b903580c.svg";